//apifetch
import axios from "axios";

//translate
import i18n from "../../translate/i18n";

//type
import { ForgetPassowrdReqType } from "./type/ForgetAndResetPassword";

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const PostForgetPasswordApi = async (data:ForgetPassowrdReqType) => {
  const token = localStorage.getItem("token");
  try {
      const response = await axios.post(`${baseURL}/auth/forget-password`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": i18n.language,
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
  }
  catch (error: any) {
      console.error(error.response?.data || error.message);
      throw error;
  }
};

